<template>
    <div class="question-item">
        <div class="question-title">{{question.title}}</div>
        <div class="option-container">
            <div :class="{'question-option':true,'active': item.selected}" v-for="(item,index) in question.options" :key="index">
                <div class="question-option-container ">
                    <div @click="selectHandler(item,index)" class="option-title ">
                        <div :class="{active: item.selected,'optionTitle': true}">{{item.label}}</div>
                        <i style="cursor: pointer" v-if="!item.selected" class="iconfont iconselect-normal"></i>
                        <i style="cursor: pointer" v-else class="iconfont iconselect-active"></i>
                    </div>
                </div>
                <div v-if="question.input && item.selected" class="input-container">
                    <input @input="inputChangeHandler(item,index)" type="text" v-model="item.input">
                </div>
                <div v-else-if="item.selected && item.input1" class="input-container">
                    <input @input="inputChangeHandler(item,index)" type="text" v-model="item.input">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ImagePreview } from 'vant';
    export default {
        name: 'question-multiple',
        props: {
            question: {required: true},
        },
        data() {
            return {
                lastIndex: [],
                show: false,
                value: []
            }
        },
        computed: {
        },
        mounted() {
            for(let k in this.question.options) {
                if(this.question.options[k].input == 1) {
                    this.question.options[k]['input1'] = 1
                    this.question.options[k]['input'] = ""

                }
            }
            // this.question.value = [{
            //     choose: '',
            //     input: '',
            //     upload: {
            //         type: 'pic',
            //         url: "",
            //         brief: "",
            //     }
            // }]
        },
        watch: {
            'question.answer': {
                handler(val) {
                    if(val) {
                        this.getAnswer()
                    }
                },
                immediate: true
            }
        },
        methods: {
            getAnswer() {
                console.log(111);
                if(this.question.answer) {
                    let arr = this.question.answer.map(item => {
                        return {
                            index: item.choose,
                            item: this.question.options[item.choose],
                            input: item.input
                        }
                    })
                    console.log(arr);
                    arr.forEach(item => {
                        this.selectHandler(item.item,item.index)
                        if(item.item.input) {
                            item.item.input = item.input
                            this.inputChangeHandler(item.item,item.index)
                        }
                    })
                }
            },
            inputChangeHandler(item,index) {
                item.input1 = 1
                let _index = this.value.findIndex(it => it.choose === index)
                this.value[_index].input = item.input
            },
            selectHandler(item,index) {
                let Iindex = this.lastIndex.findIndex(item => item === index)
                if(Iindex != -1) {
                    this.$set(item,'selected',false)
                    let valueIndex = this.value.findIndex(item => item.choose === index)
                    let Iindex = this.lastIndex.findIndex(item => item === index)
                    this.value.splice(valueIndex,1)
                    this.lastIndex.splice(Iindex,1)
                    this.question.value = this.value
                }else {
                    this.$set(item,'selected',true)
                    this.value.push({choose: index,input: ""})
                    this.question.value = this.value
                    this.lastIndex.push(index)
                }
            },




        }
    }
</script>
<style lang="scss" scoped>
    @import "questionCommon";
    .option-container {
        &.flex {
            display: flex;
            flex-wrap: wrap;
        }
        .question-option {
            &.two {
                width: 50%;
            }
            &.three {
                width: 30%;
            }
            .option-title {
                display: flex;
                width: 100%;
                .optionTitle {
                    cursor: pointer;
                    width: 100%;
                    text-align: left;
                    font-size: 16px;
                    word-wrap:break-word;
                    word-break:break-all;
                }
            }

            .option-other {
                width: 100%;
                .tips {
                    font-size: .12rem;
                    color: #ccc;
                }

            }
        }
        .input-container {
            text-align: left;
            width: 100%;
            input {
                width: 100%;
            }
        }
    }
</style>